/**
 * Desktop sidebar (APP-001 §14).
 *
 * Persistent on desktop, hidden below the lg breakpoint (the MobileNavigation
 * drawer takes over). Labeled with aria-label for screen readers.
 */
import { getPrimaryNav } from '@/config/navigation';
import { getAppLinks } from '@/config/links';
import { BrandMark } from './BrandMark';
import { NavItemLink } from './NavLinks';
import { Separator } from '@/components/ui/separator';

export function Sidebar() {
  const sections = getPrimaryNav();
  const links = getAppLinks();

  return (
    <aside
      className="hidden h-full w-60 shrink-0 flex-col border-r bg-surface lg:flex"
      aria-label="Primary navigation"
    >
      <div className="flex h-14 items-center px-4">
        <a href={links.marketingBase} className="rounded-md focus-visible:outline-none" aria-label="Signup Risk home">
          <BrandMark />
        </a>
      </div>
      <Separator />
      <nav className="flex-1 overflow-y-auto p-3">
        {sections.map((section) => (
          <div key={section.id} className="mb-4">
            <p className="px-3 pb-1 text-xs font-semibold uppercase tracking-wide text-muted-foreground">
              {section.title}
            </p>
            <ul className="space-y-1">
              {section.items.map((item) => (
                <li key={item.to}>
                  <NavItemLink item={item} />
                </li>
              ))}
            </ul>
          </div>
        ))}
      </nav>
    </aside>
  );
}
